import store from '../store/cache';
import { AppContextType } from './type';

const HEART_TIME = 30000;

enum HeartStatus {
  Ready = 'Ready',
  Pending = 'Pending',
  Ending = 'Ending',
}
/**
 * @description Heartbeat class Monitor whether the user session is maintained
 */

class Heart {
  status: string = HeartStatus.Ready;
  heart: number = 0;
  errorTimes: number = 0;

  constructor() {}

  run = (ctx: AppContextType) => {
    if (this.status === HeartStatus.Pending) return;

    this.status = HeartStatus.Pending;
    this.start(ctx);
  };

  start = (ctx: AppContextType) => {
    this.heart && window.clearInterval(this.heart);

    this.heart = window.setInterval(() => {
      if (this.errorTimes > 10) return;
      ctx.utils.services?.apis
        ?.setClientHeartbeat({
          userId: store.get('userId'),
          secretUserId: encodeURIComponent(
            decodeURIComponent(ctx.userInfo.secretUserId),
          ),
        })
        .then(() => {
          this.errorTimes = 0;
        })
        .catch((error: unknown) => {
          this.errorTimes++;
        });
    }, ctx.ext.heartTime || HEART_TIME);
  };

  stop = () => {
    this.heart && window.clearInterval(this.heart);
    this.status = HeartStatus.Ending;
  };
}

export default new Heart();
